import { FC, ReactNode } from 'react';
import { Col, Row, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlanTag } from '@/shared';

interface AdvancedSettingsSectionHeaderProps {
    description: ReactNode;
    extra?: ReactNode;
    icon: ReactNode;
    plan?: 'enterprise' | 'plus' | 'premium' | 'pro' | 'ra';
    title: ReactNode;
}

const AdvancedSettingsSectionHeader: FC<AdvancedSettingsSectionHeaderProps> = ({
    description,
    extra,
    icon,
    plan,
    title,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Row align='top' wrap={false}>
            <Col flex='auto'>
                <Typography.Title level={5}>
                    <span
                        style={{
                            color: token.colorText,
                            display: 'inline-flex',
                            marginRight: '0.5rem',
                            verticalAlign: '-0.125rem',
                        }}
                    >
                        {icon}
                    </span>
                    {title}
                    {plan && <PlanTag plan={plan} style={{ marginLeft: '0.75rem' }} />}
                </Typography.Title>
                <Typography.Paragraph style={{ color: token.colorTextTertiary }}>{description}</Typography.Paragraph>
            </Col>
            {extra && (
                <Col flex='none' style={{ textAlign: 'right' }}>
                    {extra}
                </Col>
            )}
        </Row>
    );
};

export default AdvancedSettingsSectionHeader;
